// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3BXuq","productName":"Table_productName__2IxmX"};